<script>
  import { onMount } from "svelte"
  import { get } from "svelte/store"
  import DialogBase2 from "../dialog/DialogBase2.svelte";
  import DialogTitle from "../dialog/DialogTitle.svelte";
  import DialogContent from "../dialog/DialogContent.svelte";
  import svelteI18next from "../../i18n/i18next.js";
  import { useMe } from "../../hooks/useMe.js";
  import { isDemoServerGuest } from "../../utils/demo.js";

  const me = useMe()

  let dialog
  function displayPopup() {
    // the popup is displayed only when:
    // * popup has not been displayed in the past.
    // * display language is set to Japanese.
    const hasAlreadyDisplayed = JSON.parse(window.localStorage.getItem("demo-popup"))
    const isDisplayLanguageJapanese = get(svelteI18next).language === "ja"
    const isGuestUser = isDemoServerGuest($me)

    if (!hasAlreadyDisplayed && isDisplayLanguageJapanese && isGuestUser) {
      window.localStorage.setItem("demo-popup", JSON.stringify(true))
      dialog.showModal()
    }
  }

  function closePopup() {
    dialog.close()
  }

  onMount(async () => {
    // schedule to display the popup
    setTimeout(() => displayPopup(), 4 * 60 * 1000)  // 4 minutes
  })
</script>

<DialogBase2 bind:dialog={dialog} width="min(600px, 75vw)">
  <DialogTitle onClickClose={closePopup}>
    My Schedule はいかがですか？
  </DialogTitle>
  <DialogContent>
    <div style="display: grid; grid-template-columns: auto 230px; column-gap: 1rem; row-gap: 2rem; align-items: center">
      <div class="card">
        <div>
          <div style="font-weight: bold; font-size: 1.1rem">
            Asprovaをご利用中のお客様
          </div>
          <div style="font-size: .9rem">
            すぐにフリープランをお使い頂けます。
          </div>
          <div style="font-size: .9rem; color: darkgrey">
            ※Asprova IDの登録が必要です
          </div>
        </div>
        <div>
          <a href="https://knowledge.asprova.com/hc/ja/categories/36956402963865-Asprova-My-Schedule" target="_blank">
            <img src="/assets/demo/popup_button_knowledge_center.png" alt="knowledge center banner" />
          </a>
        </div>
      </div>
      <div class="card">
        <div style="font-size: .9rem">
          <div style="font-weight: bold; font-size: 1.1rem">
            Asprovaをご利用中でないお客様
          </div>
          <div style="font-weight: bold; font-size: 1.1rem">
            さらに詳しく知りたいお客様
          </div>
          <div>
            お気軽にお問い合わせください。
          </div>
        </div>
        <div>
          <a href="https://e.apto-service.com/asprova/inquiry.html" target="_blank">
            <img src="/assets/demo/popup_button_contact.png" alt="contact banner" />
          </a>
        </div>
      </div>
    </div>
  </DialogContent>
</DialogBase2>

<style>
  .card {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: span 2;
  }
</style>
